import React from "react";
import { Form } from "react-bootstrap";
// import { NavLink } from "react-router-dom";
// import {
//   pathNewsSubAll,
//   pathNewsSubImportant,
//   pathNewsSubPinned,
// } from "../../../common/config/vars";
import { IDemGroup } from "../logics/demandGroups";

interface IGroupsSelect {
  setSel: React.Dispatch<React.SetStateAction<string>>;
  groups: IDemGroup[];
  sel: string;
  disabled: boolean;
}

export const GroupsSelect = ({
  setSel,
  groups,
  sel,
  disabled,
}: IGroupsSelect) => {
  return (
    <Form.Control
      disabled={disabled}
      as="select"
      size="sm"
      value={sel}
      custom
      style={{ borderRadius: "12px", marginBottom: "24px" }}
      onChange={(e) => setSel(e.target.value)}
    >
      {groups.map((g, i) => (
        <option key={i} value={g.id}>
          {g.name}
        </option>
      ))}
    </Form.Control>
  );
};
